<template src="./Projects.html"></template>

<script>
import { mapGetters } from 'vuex'
import { getProjects, getProject, deleteProject } from '../../services'
import { OnlyAdmin } from '../../utils/roles'
import ProjectFormDialog from '../../components/Project/ProjectFormDialog.vue'

export default {
  name: 'Projects',
  components: { ProjectFormDialog },
  data: () => ({
    // Evita reinicializar más de una vez si el watcher de `user` dispara de nuevo (ver watcher).
    initialized: false,
    loading: false,
    projects: [],
    formDialogOpen: false,
    selectedProject: null,
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Descripción', value: 'description' },
      { text: 'Estado', value: 'active' },
      { text: '', value: 'actions', sortable: false, align: 'end', width: 104 }
    ]
  }),
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    // `user` lo puebla Vuex de forma asíncrona (después de que Firebase resuelve el estado de
    // auth) — en una recarga dura de página este componente puede montarse antes de que esté
    // listo. Mismo fix aplicado a Home.vue (XAN-151): sin esto, un `created()` que lea
    // `this.user?.rol` directamente podría dejar pasar un rol no permitido si `user` aún es null.
    user: {
      immediate: true,
      handler (user) {
        if (!user || this.initialized) return
        this.initialized = true

        // XAN-193 (adjustments) — managing projects is ADMIN-only: create, edit, delete and
        // assign members. Blocks direct URL access, not just the menu entry; the backend
        // endpoints enforce the same.
        if (!OnlyAdmin()(user.rol)) {
          this.$router.replace('/')
          return
        }

        this.fetchProjects()
      }
    }
  },
  methods: {
    async fetchProjects () {
      this.loading = true
      try {
        this.projects = await getProjects()
      } catch (err) {
        console.error('Error fetching projects:', err)
      } finally {
        this.loading = false
      }
    },
    openCreate () {
      this.selectedProject = null
      this.formDialogOpen = true
    },
    async openEdit (project) {
      try {
        // La lista (getProjects) no trae miembros — se recarga el detalle completo para editar.
        this.selectedProject = await getProject(project.id)
        this.formDialogOpen = true
      } catch (err) {
        console.error('Error loading project detail:', err)
      }
    },
    confirmDelete (project) {
      this.$swal({
        title: '¿Está seguro de eliminar el proyecto?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) { this.removeProject(project) }
      })
    },
    async removeProject (project) {
      try {
        await deleteProject(project.id)
        this.$swal({ text: 'Proyecto eliminado.', buttons: false, icon: 'success', timer: 2500 })
        this.fetchProjects()
      } catch (err) {
        console.error('Error deleting project:', err)
        this.$swal({
          text: err.message ?? 'Ocurrió un error, intenta más tarde.', buttons: false, icon: 'error', timer: 3000
        })
      }
    }
  }
}
</script>

<style lang="scss" src="./Projects.scss" scoped></style>
